/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_Invitation_ExpiredInputs */

const en_us2_group_invitation_expired = /** @type {(inputs: Group_Invitation_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This invitation expired. Ask your trainer for a new one.`)
};

const pt_br2_group_invitation_expired = /** @type {(inputs: Group_Invitation_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este convite expirou. Peça um novo ao seu personal.`)
};

const pt_pt2_group_invitation_expired = /** @type {(inputs: Group_Invitation_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este convite expirou. Peça um novo ao seu personal.`)
};

/** @type {(inputs: Group_Invitation_ExpiredInputs) => LocalizedString} */
const es_419_group_invitation_expired = en_us2_group_invitation_expired;

/** @type {(inputs: Group_Invitation_ExpiredInputs) => LocalizedString} */
const fr_fr2_group_invitation_expired = en_us2_group_invitation_expired;

/** @type {(inputs: Group_Invitation_ExpiredInputs) => LocalizedString} */
const de_de2_group_invitation_expired = en_us2_group_invitation_expired;

/** @type {(inputs: Group_Invitation_ExpiredInputs) => LocalizedString} */
const it_it2_group_invitation_expired = en_us2_group_invitation_expired;

/**
* | output |
* | --- |
* | "This invitation expired. Ask your trainer for a new one." |
*
* @param {Group_Invitation_ExpiredInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const group_invitation_expired = /** @type {((inputs?: Group_Invitation_ExpiredInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Group_Invitation_ExpiredInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_group_invitation_expired(inputs)
	if (locale === "es-419") return es_419_group_invitation_expired(inputs)
	if (locale === "pt-PT") return pt_pt2_group_invitation_expired(inputs)
	if (locale === "fr-FR") return fr_fr2_group_invitation_expired(inputs)
	if (locale === "de-DE") return de_de2_group_invitation_expired(inputs)
	if (locale === "it-IT") return it_it2_group_invitation_expired(inputs)
	return en_us2_group_invitation_expired(inputs)
});
export { group_invitation_expired as "group.invitation_expired" }